module.exports = __webpack_public_path__ + "static/media/ncb shot 03.5c476b47.webp";